<template>
  <div class="content">
    <h2 class="font-light">Training Record Files</h2>
    <server-error v-bind:error="error.serverError"></server-error>
    <div class="row">
      <div v-for="file in fileIndex" v-bind:key="file.id" class="col-6">
        <div class="tile tile--center u-box">
          <div class="tile__container">
            <div class="row">
              <div class="col-9 ignore-screen">
                <div class="tile__title">
                  <div>{{ file.name }}</div>
                </div>
                <div class="tile__subtitle">
                  <div>{{ file.arn }}</div>
                </div>
                <div class="info">
                  <div>
                    <div class="tag tag--info">{{ file.num_records }}</div>
                    Records |
                    <strong>Last Record: </strong>
                    {{ formatDate(file.last_record) }}
                  </div>
                </div>
              </div>
              <div class="col-3 ignore-screen --list-table-action-button">
                <button
                  class="btn btn-info btn-small btn-animated u-pull-right"
                >
                  <router-link
                    v-bind:to="{ name: 'record-file', params: { id: file.id } }"
                  >
                    Open
                  </router-link>
                </button>
              </div>
            </div>
          </div>
        </div>
        <space></space>
      </div>
    </div>
  </div>
</template>
<script>
import { DateFormatter } from "@/functions/dateFormat.function";
import { mapGetters } from "vuex";
import ServerError from "@/components/ServerError";

export default {
  name: "record-user-file-index",
  components: {
    ServerError
  },
  computed: {
    ...mapGetters("records", ["fileIndex"]),
    ...mapGetters("core", ["error"])
  },
  methods: {
    formatDate: function(dateString) {
      return DateFormatter(dateString);
    }
  },
  mounted() {
    this.$store.dispatch("records/listFiles");
  }
};
</script>
